import { useCallback } from 'react';
import { EventBus } from '@vtblife/event-bus';

import { useChatStateContext } from '../components/NewBuildingCard/ChatStateProvider';

export const useChat = () => {
    const {
        initialClientMessage
    } = useChatStateContext();

    const eventBus = EventBus.getInstance();

    const openChat = useCallback(() => {
        eventBus.publish({
            type: 'chat:open',
            category: 'simple',
            data: {
                chatType: 'SUPPORT_CHAT',
                initialMessage: initialClientMessage
            }
        });
    }, [ initialClientMessage, eventBus ]);

    const closeChat = useCallback(() => {
        if (! eventBus) {
            return;
        }

        eventBus.publish({
            type: 'chat:close',
            category: 'simple',
            data: {}
        });
    }, [ eventBus ]);

    return {
        openChat,
        closeChat
    };
};
